import './AnchorItem.css';
import React, { useEffect, useRef, useState } from 'react';
import { get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useHistory } from 'react-router-dom';
const commonStyles = "cq6qp7s";
const scrollToRef = ref => ref.current.scrollIntoView({
  behavior: 'smooth'
});
const AnchorItem = _ref => {
  let {
    fields,
    params
  } = _ref;
  const title = get(fields, 'data.datasource.title.jss.value');
  const id = `anchor-item-${Math.random().toString(36).slice(2)}`;
  const venueTitle = get(fields, 'data.contextItem.title.jss.value');
  const tabTextAnalytics = get(fields, 'data.tabTextAnalytics');
  const anchorUrlParameter = params['Anchor Url Parameter'];
  const componentRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);
  const history = useHistory();
  const hash = history.location.hash && history.location.hash.split('#')[1] || null;
  const handleScroll = () => {
    // @ts-ignore
    if (componentRef && componentRef.current && componentRef.current.offsetTop != offsetTop)
      // @ts-ignore
      setOffsetTop(componentRef.current.offsetTop || 0);
  };
  useEffect(() => {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      scrollToRef(componentRef);
    }
  }, [offsetTop]);
  useEffect(() => {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    "data-id": "anchor-item",
    "data-anhor": anchorUrlParameter,
    ref: componentRef,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(tabTextAnalytics, params), [venueTitle, title]);
    },
    id: id,
    "data-title": title,
    className: commonStyles
  });
};
export default AnchorItem;